export default "__VITE_ASSET__3etsj$BN__"